// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1cJAb","cell":"ColumnAccessor_cell__3Tzdw","firstCellAccent":"ColumnAccessor_firstCellAccent__S5f-D"};